function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import regeneratorRuntime from "regenerator-runtime";
import { debounce } from "lodash";
import { Result } from "../../../types/util";
import { updateContextState } from "../wr-context";
var DEBUG = true;
export var WorkflowUnit = function WorkflowUnit(id, actions) {
    "use strict";
    var _this = this;
    _classCallCheck(this, WorkflowUnit);
    this.before = null;
    this.after = null;
    this.currentActionIndex = -1;
    var _this1 = this;
    this.next = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(next) {
            var action, actionFn;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this1.currentActionIndex += 1;
                        action = _this1.actions[_this1.currentActionIndex];
                        actionFn = action === null || action === void 0 ? void 0 : action.fn;
                        if (DEBUG) {
                            console.log("Running next action [".concat(_this1.currentActionIndex, "] for unit ").concat(_this1.id, " -"), action.id);
                        }
                        _ctx.next = 6;
                        return actionFn(next);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(next) {
            return _ref.apply(this, arguments);
        };
    }();
    // Returns true if resync has occurred
    this.resync = function() {
        var resyncedActionIndex = _this.actions.findIndex(function(action) {
            var ref;
            return (ref = action.resyncPredicate) === null || ref === void 0 ? void 0 : ref.call(action);
        });
        if (resyncedActionIndex !== -1) {
            _this.currentActionIndex = resyncedActionIndex;
            return true;
        } else {
            return false;
        }
    };
    this.isExhausted = function() {
        return _this.currentActionIndex >= _this.actions.length - 1;
    };
    this.reset = function() {
        _this.currentActionIndex = -1;
    };
    this.id = id;
    this.actions = actions;
};
export var Workflow = function Workflow(id, units) {
    "use strict";
    var _this = this;
    _classCallCheck(this, Workflow);
    this.units = [];
    this.currentUnitIndex = 0;
    this.getCurrentUnit = function() {
        return _this.units[_this.currentUnitIndex];
    };
    var _this1 = this;
    this.next = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var unit, isCurrentUnitExhausted, nextCb;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    unit = _this1.getCurrentUnit();
                    isCurrentUnitExhausted = unit.isExhausted();
                    if (isCurrentUnitExhausted) {
                        _this1.nextUnit();
                        unit = _this1.getCurrentUnit();
                    }
                    if (unit) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", new Result(new Error("all units exhausted")));
                case 5:
                    _ctx.prev = 5;
                    nextCb = function() {
                        return setTimeout(_this1.next, 0);
                    };
                    _ctx.next = 9;
                    return unit.next(nextCb);
                case 9:
                    return _ctx.abrupt("return", new Result(undefined));
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](5);
                    if (!_instanceof(_ctx.t0, Error)) {
                        _ctx.next = 19;
                        break;
                    }
                    console.error("Workflow error:", _ctx.t0);
                    return _ctx.abrupt("return", new Result(_ctx.t0));
                case 19:
                    return _ctx.abrupt("return", new Result(new Error("unknown error")));
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                5,
                12
            ]
        ]);
    }));
    this.nextUnit = function() {
        _this.currentUnitIndex += 1;
        // Update context state when units change
        updateContextState(function() {});
    };
    this.resync = debounce(function() {
        var resyncedUnitIndex = _this.units.findIndex(function(unit) {
            return unit.resync();
        });
        if (resyncedUnitIndex !== -1) {
            _this.currentUnitIndex = resyncedUnitIndex;
            // Reset all later units
            _this.units.slice(resyncedUnitIndex + 1).forEach(function(unit) {
                unit.reset();
            });
        }
    }, 10);
    this.startResyncListener = function(context) {
        context.history.listen(_this.resync);
    };
    this.id = id;
    this.units = units;
};
export var makeAction = function(kind, fn, resyncFn) {
    return {
        id: kind,
        fn: fn,
        resyncPredicate: resyncFn
    };
};
